module.exports = __webpack_public_path__ + "img/ga.3bccb265.svg";